{
  "title": "Documents",
  "description": "The knowledge base agents search: upload files, organise them in folders and keep the index fresh.",
  "tabs": {
    "documents": "Documents",
    "index": "Index & schedule"
  },
  "actions": {
    "close": "Close",
    "delete": "Delete",
    "download": "Download",
    "editText": "Edit text",
    "move": "Move",
    "new": "New",
    "open": "Open",
    "showInFolder": "Show in folder"
  },
  "tree": {
    "label": "Folders",
    "all": "All documents",
    "breadcrumbs": "Folder path",
    "collapse": "Collapse",
    "expand": "Expand",
    "actions": "Actions for {{name}}"
  },
  "folders": {
    "root": "Top level",
    "new": "New folder",
    "newSub": "New subfolder",
    "newTitle": "New folder",
    "newDescription": "Folders organise documents; agents can search within a folder.",
    "create": "Create folder",
    "parent": "Location",
    "name": "Name",
    "namePlaceholder": "e.g. handbook",
    "delete": "Delete folder",
    "deleteTitle": "Delete folder “{{name}}”?",
    "deleteWithDocs_one": "This permanently deletes the folder, its subfolders and {{count}} document inside.",
    "deleteWithDocs_other": "This permanently deletes the folder, its subfolders and all {{count}} documents inside.",
    "deleteEmpty": "The folder is empty and will be removed.",
    "missing": {
      "title": "Folder not found",
      "description": "“{{path}}” doesn't exist (anymore)."
    }
  },
  "move": {
    "renameOrMove": "Rename or move",
    "documentTitle": "Move or rename document",
    "folderTitle": "Move or rename folder",
    "description": "Currently at {{path}}.",
    "destination": "Destination folder",
    "fileName": "File name",
    "fileNameHint": "Uploaded files keep their extension.",
    "submit": "Move"
  },
  "newDoc": {
    "action": "New document",
    "title": "New document",
    "description": "Write a text document directly in the knowledge base. Names without an extension become Markdown (.md).",
    "create": "Create document",
    "content": "Content",
    "contentHint": "Markdown is supported."
  },
  "validation": {
    "segment": "Use a single name without slashes."
  },
  "documents": {
    "title": "Documents",
    "columns": {
      "name": "Name",
      "index": "Index",
      "size": "Size",
      "updated": "Updated"
    },
    "count_one": "{{count}} document",
    "count_other": "{{count}} documents",
    "docCount_one": "{{count}} document",
    "docCount_other": "{{count}} documents",
    "search": "Search by name or title…",
    "searchIn": "Search in {{folder}}…",
    "deleteTitle": "Delete “{{name}}”?",
    "deleteDescription": "The document and its search index are removed. Agents can no longer find it.",
    "empty": {
      "title": "No documents yet",
      "description": "Upload PDFs, Word, spreadsheets, Markdown or text files, or drop them here."
    },
    "emptyFolder": {
      "title": "This folder is empty",
      "description": "Drop files here or upload them into this folder."
    }
  },
  "indexState": {
    "indexed": "Indexed",
    "indexedHint": "Embedded with the current model; found by meaning and keywords.",
    "pending": "Not indexed",
    "pendingHint": "Changed or new since the last index run; found by keywords until indexed.",
    "failed": "Failed",
    "failedHint": "Indexing failed.",
    "keyword": "Keyword only",
    "keywordHint": "No embedding model is configured, so search uses keywords."
  },
  "mode": {
    "hybrid": "Hybrid search",
    "keyword": "Keyword search"
  },
  "detail": {
    "preview": "Preview",
    "details": "Details",
    "content": "Document text",
    "noText": "No text",
    "noTextHint": "No text could be extracted from this file.",
    "extracted": "Text extracted from the uploaded file. Download the original for the exact layout.",
    "truncated": "Showing the first {{shown}} of {{total}} characters. Download the file to see everything.",
    "reindexHint": "Saving marks the document for re-indexing.",
    "indexError": "Indexing failed:",
    "path": "Path",
    "type": "Type",
    "size": "Size",
    "characters": "Characters",
    "chunks": "Chunks",
    "indexStatus": "Index",
    "indexedAt": "Indexed",
    "notIndexed": "Not yet",
    "created": "Created",
    "updated": "Updated",
    "sha": "SHA-256 checksum",
    "source": "Source",
    "sourceText": "Written in-app",
    "sourceUpload": "Uploaded file",
    "metadata": "Title & tags",
    "titleField": "Title",
    "titleHint": "Shown in search results instead of the file name.",
    "tags": "Tags",
    "related": "Related documents",
    "noRelated": "No related documents.",
    "relatedMissing": "“{{path}}” no longer exists."
  },
  "upload": {
    "action": "Upload",
    "title": "Upload documents",
    "description": "Files with the same name in the destination are replaced.",
    "destination": "Destination folder",
    "drop": "Drop files here or click to choose",
    "types": "PDF, Word, Excel, Markdown, text, CSV, JSON and code · max 50 MB per file",
    "dropHere": "Drop to upload to {{folder}}",
    "progress": "Upload progress",
    "remove": "Remove {{name}}",
    "saved": "Uploaded",
    "error": "Failed",
    "skipped": "Skipped",
    "reject": {
      "type": "This file type is not supported.",
      "size": "Larger than 50 MB.",
      "empty": "The file is empty."
    },
    "partial": "{{saved}} uploaded, {{failed}} failed — see the list for details.",
    "done_one": "{{count}} document uploaded",
    "done_other": "{{count}} documents uploaded",
    "failed_one": "{{count}} file could not be uploaded",
    "failed_other": "{{count}} files could not be uploaded",
    "submit_one": "Upload {{count}} file",
    "submit_other": "Upload {{count}} files",
    "summary_one": "{{count}} file · {{size}}",
    "summary_other": "{{count}} files · {{size}}"
  },
  "index": {
    "title": "Search index",
    "description": "Documents are split into chunks and embedded so agents can find them by meaning. Keyword search always works.",
    "run": "Index changes",
    "running": "Indexing…",
    "more": "More index actions",
    "rebuild": "Rebuild full index",
    "rebuildTitle": "Rebuild the full index?",
    "rebuildDescription": "Every document is embedded again, which costs embedding tokens. Search keeps working during the rebuild.",
    "notConfigured": "Configure an embedding model first.",
    "summary": "{{indexed}} of {{total}} documents indexed",
    "keywordOnly": "No embedding model configured — keyword search only.",
    "lastRun": "Last run",
    "stale_one": "{{count}} to index",
    "stale_other": "{{count}} to index",
    "failed_one": "{{count}} failed",
    "failed_other": "{{count}} failed"
  },
  "embedding": {
    "mode": "Search mode",
    "provider": "Provider",
    "model": "Embedding model",
    "dimensions": "Dimensions",
    "modelDefault": "Model default",
    "none": "Not set",
    "configure": "Embedding settings",
    "unusable": "Embedding configuration can't be used",
    "notConfiguredTitle": "Keyword search only",
    "notConfigured": "Choose an embedding provider and model in the organization settings to enable semantic (hybrid) search."
  },
  "schedule": {
    "title": "Schedule",
    "description": "Index changed documents automatically.",
    "enabled": "Index automatically",
    "enabledHint": "Runs an incremental index on the interval below.",
    "needsModel": "Runs only once an embedding model is configured.",
    "every": "Every",
    "unit": "Unit",
    "hours": "Hours",
    "days": "Days",
    "lastRun": "Last run",
    "nextRun": "Next run"
  },
  "jobs": {
    "title": "Index runs",
    "description": "The 20 most recent index jobs.",
    "full": "Full rebuild",
    "incremental": "Incremental",
    "preparing": "Preparing…",
    "progress": "{{done}} of {{total}} documents",
    "progressLabel": "Index progress",
    "status": {
      "pending": "Queued",
      "running": "Running",
      "completed": "Completed",
      "failed": "Failed"
    },
    "trigger": {
      "manual": "Started manually",
      "schedule": "Scheduled"
    },
    "columns": {
      "status": "Status",
      "kind": "Run",
      "documents": "Documents",
      "chunks": "Chunks",
      "duration": "Duration",
      "started": "Started"
    },
    "empty": {
      "title": "No index runs yet",
      "description": "Runs appear here once you index the knowledge base."
    },
    "failedCount_one": "{{count}} failed",
    "failedCount_other": "{{count}} failed"
  },
  "stats": {
    "documents": "Documents",
    "indexed": "Indexed",
    "chunks": "Chunks",
    "storage": "Storage",
    "byType": "File types",
    "byTypeDescription": "What the knowledge base consists of.",
    "lastIndexed": "Last indexed",
    "lastUpdated": "Last change",
    "folders_one": "in {{count}} folder",
    "folders_other": "in {{count}} folders",
    "embedded_one": "{{count}} embedded",
    "embedded_other": "{{count}} embedded",
    "chars_one": "{{count}} character of text",
    "chars_other": "{{count}} characters of text",
    "typeLine_one": "{{count}} document · {{size}}",
    "typeLine_other": "{{count}} documents · {{size}}"
  },
  "search": {
    "title": "Knowledge search",
    "description": "Search the knowledge base the way agents do: by meaning and by keywords.",
    "placeholder": "Ask a question or search for keywords…",
    "submit": "Search",
    "clear": "Clear search",
    "folder": "Folder",
    "allFolders": "All folders",
    "limit": "Number of results",
    "hybridHint": "Combines semantic similarity (embeddings) with keyword matches.",
    "keywordHint": "Only keyword matches: configure an embedding model for semantic search.",
    "idle": {
      "title": "Search the knowledge base",
      "description": "Results show the best matching passages, grouped per document."
    },
    "noDocs": {
      "title": "The knowledge base is empty",
      "description": "Upload documents first, then search them here.",
      "action": "Go to documents"
    },
    "empty": {
      "title": "No matches",
      "description": "Nothing in the knowledge base matches “{{query}}”. Try other words or another folder."
    },
    "similarity": "{{value}}% similar",
    "similarityHint": "Cosine similarity between the question and this passage.",
    "keywordMatch": "Keyword match",
    "keywordMatchHint": "This passage contains words from the query.",
    "limitValue_one": "{{count}} result",
    "limitValue_other": "{{count}} results",
    "resultCount_one": "{{count}} passage",
    "resultCount_other": "{{count}} passages",
    "resultDocs_one": "in {{count}} document",
    "resultDocs_other": "in {{count}} documents",
    "moreChunks_one": "+ {{count}} more matching passage",
    "moreChunks_other": "+ {{count}} more matching passages"
  },
  "toasts": {
    "created": "Created {{path}}",
    "updated": "Saved {{path}}",
    "deleted": "Deleted {{path}}",
    "folderCreated": "Folder {{path}} created",
    "folderDeleted": "Folder {{path}} deleted",
    "moved": "Moved to {{to}}",
    "indexStarted": "Indexing started",
    "rebuildStarted": "Full rebuild started",
    "scheduleSaved": "Schedule saved"
  }
}
